@if(loading){
<div class="loader">
    <div class="loaderImg"><img src="./assets/images/loading.gif" alt="" /></div>
</div>
}
@if (!isPageReady) {
<div class="spur-page-loader" role="status" aria-live="polite" aria-busy="true">
    <div class="spur-page-loader__inner">
        <div class="spur-page-loader__visual" aria-hidden="true">
            <span class="spur-page-loader__orbit"></span>
            <span class="spur-page-loader__mark"></span>
        </div>
        <p class="spur-page-loader__brand">Spur Experiences</p>
        <p class="spur-page-loader__line">Loading charities…</p>
    </div>
</div>
} @else {
<section>
    <div class="container-fluid">
        @if(result && result.sections[0].section_data){
        <div class="row">
            <div class="col-12 px-0 charity_reg parentLoading">
                <owl-carousel-o [options]="owlCharity">
                    @for(addImg of result.sections[0].section_data;track addImg){
                    <ng-template carouselSlide [width]="350" [id]="addImg.id">
                        <div class="item charities-slider">
                            <img class="lazyload"
                                [attr.data-src]="addImg.image ? page_image_url+addImg.image : '../../../../assets/images/option_img.png'"
                                alt="" src="../../../../assets/images/loading.gif">
                        </div>
                    </ng-template>
                    }
                </owl-carousel-o>

                <div class="ticket_bg d-flex align-items-end justify-content-center">
                    <div class="ticket_reg">
                        <a routerLink="/find-couple" class="primary-btn primary-btn-main">Find a Registry</a>
                        @if(!authUser){
                        <a routerLink="/registration/wedding-couple" class="primary-btn primary-btn-new">
                            Create a Registry</a>
                        }
                    </div>
                </div>
            </div>
        </div>
        }@else{
        <ngx-skeleton-loader count="14" appearance="line"></ngx-skeleton-loader>
        }
    </div>


    <!-- ====== vebo gives =============== -->
    <div class="vebo_padding">
        @if(result && result.sections[1]){
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h1>{{result.sections[1].name}}</h1>
                </div>
            </div>
            <div class="row">
                <div class='col-12 col-md-12 text-center ' [innerHTML]="result.sections[1].description | appendDollar">
                </div>
            </div>
        </div>
        }
    </div>

    <!-- =============== charity category ====================== -->
    <div class="charity_category">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h2>Explore Our Featured Charities</h2>
                </div>
                <div class="col-12">
                    <div class="srch_charty">
                        <form>

                            <div class="ser_hd">
                                <input type="text" class="form-control" name="search_string" id="search_string"
                                    placeholder="Search" [(ngModel)]="search_string" (ngModelChange)='changed($event)'>
                                <span class="sr_btn srchbtn">
                                    <svg width="19" height="19" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M14.9536 14.9458L21 21M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z"
                                            stroke="#555" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round"></path>
                                    </svg>
                                </span>
                            </div>
                        </form>
                        @if(authUser){
                        <div class="custom-checked">
                            <input type="checkbox" id="chkBoxed" (change)="onCharitiesBase($event)" />
                            <label for="chkBoxed">
                                <span class="charities-state">Only show charities based in my state</span>
                            </label>
                        </div>
                        }
                        @if(fromPage){
                        <div>
                            <a href="javascript:void(0);"
                                [routerLink]='[authUser?.role_id == 1 ? "/profile" : authUser?.role_id==3 ? "/your-profile/charity" :   authUser?.role_id==2 ? "/ep-profile" : authUser?.role_id==4 ? "/my-profile" : authUser?.role_id==5 ? "/bbb-profile" : "/profile"]'>
                                <span class="d-inline-block ml-auto">
                                    <strong>
                                        Back to profile
                                    </strong>
                                </span>
                            </a>
                        </div>
                        }
                    </div>


                </div>

            </div>
            <div class="row" [hidden]="show_category">
                <div class="col-12 px-0">
                    @if(category_data){
                    <ul class="list-unstyled mb-0 charity_gallery">
                        @for(category of category_data;track category){
                        <li>
                            <a routerLink="/charity-category/{{category.slug}}" class="list_box banner lazyload"
                                [attr.data-bg]="image_url+category.image"
                                style="background-image:url(../../../assets/images/loading.gif);">

                                <div class="overLay_list">
                                    <span class="list_hov_title">{{ category?.name }}</span>
                                    <span class="list_hov_cont" [innerHTML]="category?.description | appendDollar">
                                    </span>
                                </div>
                            </a>
                        </li>
                        }
                    </ul>
                    }
                </div>
            </div>

            <div [hidden]="show_charity" class="SelectExpCoupleBody">
                @if(charities_data && charities_data.length > 0){
                <ul class="products-list">
                    @for(charity_data1 of charities_data;track charity_data1){
                    <li class="products position-relative">
                        <a href="javascript:void(0);" routerLink="/charities/{{charity_data1.slug}}">
                            <!-- please make sure that Image Should be 340X332 -->
                            <div class="product-image position-relative lazyload"
                                [attr.data-bg]="(charity_data1.image) ? charites_url+charity_data1.image : 'assets/images/option_img.png'">
                                <img class="lazyload"
                                    [attr.data-src]="charity_data1.image ? charites_url+charity_data1.image : 'assets/images/option_img.png'"
                                    src="assets/images/loading.gif" alt="">

                                @if(authUser?.charity_choosed==charity_data1.id){
                                <div class="selectedMsg">selected</div>
                                }
                            </div>
                            <div class="product-info">
                                <div class="product-name">
                                    <h2>{{charity_data1.title}}</h2>
                                </div>
                            </div>
                        </a>
                        <div class="subtitleCharityCat">
                            <b>{{charity_data1.sub_title}}</b>
                        </div>

                        <!--   hover btn of listing---- -->
                        @if(authUser){
                        <div class="btnGroupCharityHead">
                            @if(authUser?.role_id=='1'){
                            <div class="btnGroupCharityCategory">
                                @if(authUser?.charity_choosed!=charity_data1?.id){
                                <a href="javascript:void(0);"
                                    (click)="charitySelection(charity_data1?.id, charity_data1?.title)"
                                    class="chosseCate">choose charity</a>
                                }
                                <a href="javascript:void(0);" (click)="charity_detail(charity_data1.slug)"
                                    class="viewCate">view details</a>
                            </div>
                            }
                        </div>
                        }
                    </li>
                    }
                </ul>
                }
                @if(charities_data?.length == 0){
                <div>
                    <div class="nt_found_dv">No Data Found</div>
                </div>
                }
            </div>
        </div>
    </div>

    <div class="more_info">
        @if(result && result?.sections[2]){
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h2>{{result?.sections[2]?.name}}</h2>
                </div>
            </div>
            <div class="row">
                <div class="col-12 text-center description"
                    [innerHTML]="result?.sections[2]?.description | appendDollar">
                </div>
            </div>
        </div>
        }
    </div>
</section>

<!-- Custom Magnific Popup -->
<div id="video-popup-wrapper" hidden>
    <div id="magni-overlay"></div>
    <div class="mfp-wrap mfp-close-btn-in mfp-auto-cursor mfp-ready">
        <div class="mfp-container mfp-s-ready mfp-iframe-holder">
            <div class="mfp-content">
                <div class="mfp-iframe-scaler">
                    <button title="Close (Esc)" type="button" (click)="closeVideoPopup($event)"
                        class="mfp-close">×</button>
                    <iframe id="videoIframe" class="mfp-iframe" frameborder="0" allowfullscreen=""></iframe>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- ------------  modal ------------------ -->

<div class="modal fade charityfullmodal" id="experienceDetailsPopup" bsModal #experienceDetailsPopup="bs-modal"
    tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <button type="button" class="close" (click)="close()" data-dismiss="modal" aria-label="Close">
                <i class="fa fa-times"></i>
            </button>
            <div class="modal-body">
                <section>
                    @if(charity_detail_data){
                    <div class="container-fluid">
                        <div class="row registeryParent parentLoading lazyload"
                            [attr.data-bg]="charity_detail_data?.cover_image ? profile_url+charity_detail_data.cover_image : '../../../../assets/images/option_img.png'"
                            [ngStyle]="{
                                    'background-image': charity_detail_data?.cover_image
                                    ? 'url(' + profile_url+charity_detail_data?.cover_image + ')'
                                    : 'url(' +
                                        '../../../../assets/images/option_img.png' +
                                        ')'
                                }">
                            <div class="col-12 px-0 h-100">
                                <h2 class="comName">{{charity_detail_data?.title}}
                                    <p class="webName"><span>{{charity_detail_data?.sub_title}}</span></p>
                                </h2>
                                <div class="profileImg">
                                    <figure class="lazyload" [ngStyle]="{
                                            'background-image': charity_detail_data?.profile_image
                                            ? 'url(' + profile_url+charity_detail_data?.profile_image + ')'
                                            : 'url(' +
                                                'assets/images/option_img.png' +
                                                ')'
                                        }"
                                        [attr.data-bg]="charity_detail_data?.profile_image ? profile_url+charity_detail_data?.profile_image : 'assets/images/option_img.png'">
                                        <img class="lazyload"
                                            [attr.data-src]="charity_detail_data?.profile_image ? profile_url+charity_detail_data?.profile_image : 'assets/images/option_img.png'"
                                            alt="" />
                                    </figure>
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                    <!-- Return to search btn  -->
                    <div class="productReview">
                        <h3 class="productInfo_head">SPUR gives 5% of the sales from our registry to the charity that
                            we've selected.</h3>
                        <div class="container">

                            <div class="productInfo">
                                @if(charity_detail_data){
                                <div class="form-row">
                                    <div class="col-12 col-md-4">
                                        <div class="productInfo_owl">
                                            @if(charity_detail_data.image){
                                            <div class="item">
                                                <img class="lazyload"
                                                    [attr.data-src]="charity_detail_url+charity_detail_data.image"
                                                    alt="" [src]="charity_detail_url+charity_detail_data.image">
                                            </div>
                                            }@else{
                                            <div class="item ">
                                                <img class="lazyload" data-src="assets/images/option_img.png" alt=""
                                                    src="../../../../assets/images/loading.gif">
                                            </div>
                                            }
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-8">
                                        <div class="add-experiences_modalright">
                                            <div class="productDes">
                                                <h5>{{charity_detail_data.title}}</h5>
                                            </div>
                                            <ul class="modelLinklist">
                                                <li><a href="javascript:void(0);">{{charity_detail_data?.website}}</a>
                                                </li>
                                                <li>
                                                    <a
                                                        href="javascript:void(0)">{{charity_detail_data?.phone_number}}</a>
                                                    &nbsp; {{charity_detail_data?.email ? '|' : ''}} &nbsp; <a
                                                        href="javascript:void(0);">{{charity_detail_data?.email}}</a>
                                                </li>
                                            </ul>

                                            <!-- Review Block END -->
                                            <div class="buyadd_btns">
                                                @if(authUser?.charity_choosed!=charity_detail_data?.id){
                                                <div>
                                                    <button class="btn btnadd" data-dismiss="modal" aria-label="Close"
                                                        (click)="charitySelection(charity_detail_data.id,  charity_detail_data.title)">choose
                                                        charity </button>
                                                </div>
                                                }@else{
                                                <button class="btn btnadd">selected</button>
                                                }
                                                <div>
                                                    <button class="btn btnadd btnBack" (click)="close()"
                                                        data-dismiss="modal" aria-label="Close">back </button>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                        <div class="productTabInfo">
                            <div class="container">
                                <div class="row">
                                    <div class="col-12">
                                        <ul class="nav nav-tabs" id="myTab" role="tablist">
                                            <li class="nav-item">
                                                <a class="nav-link active" id="summar-tab" data-toggle="tab"
                                                    href="#summar" role="tab" aria-controls="summar"
                                                    aria-selected="true">SUMMARY</a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link" id="detTab-tab" data-toggle="tab" href="#detTab"
                                                    role="tab" aria-controls="detTab" aria-selected="false">DETAILS</a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link" id="rewTab-tab" data-toggle="tab" href="#rewTab"
                                                    role="tab" aria-controls="rewTab" aria-selected="false">LOCATION</a>
                                            </li>
                                        </ul>
                                        @if(charity_detail_data){
                                        <div class="tab-content" id="myTabContent">
                                            <div class="tab-pane fade show active" id="summar" role="tabpanel"
                                                aria-labelledby="summar-tab">
                                                <div class="summaryDetailTab">
                                                    <div class="container">
                                                        <div class="row">
                                                            <div class="col-12 px-0">
                                                                <div class="headingParent">
                                                                    <p [innerHTML]="charity_detail_data.summary"></p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="tab-pane fade" id="detTab" role="tabpanel"
                                                aria-labelledby="detTab-tab">

                                                <div class="summaryDetailTab">
                                                    <div class="container">
                                                        <div class="row">
                                                            <div class="col-12 px-0">
                                                                <div class="headingParent">
                                                                    <p
                                                                        [innerHTML]="charity_detail_data.description | appendDollar">
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="tab-pane fade" id="rewTab" role="tabpanel"
                                                aria-labelledby="rewTab-tab">

                                                <div class="summaryDetailTab">
                                                    <div class="container">
                                                        <div class="row">
                                                            <div class="col-12 px-0">
                                                                <div class="headingParent">
                                                                    <p [innerHTML]="charity_detail_data.location"></p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</div>
}